import React from 'react';
import { CarouselRef } from 'antd/lib/carousel';
import { Button } from '../Button';
import { FontAwesomeIcon } from '../FontAwesomeIcon';
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import Styles from './Carousel.module.less';
import { isFirst, isLast } from '../../lib';

const ControlButtons = ({
    carousel,
    current,
    totalCount,
}: {
    carousel: React.RefObject<CarouselRef>;
    current: number;
    totalCount: number;
}): JSX.Element => (
    <div className={Styles.buttons}>
        <Button
            shape="circle"
            size="large"
            icon={<FontAwesomeIcon icon={faArrowLeft} />}
            disabled={isFirst(current)}
            onClick={() => {
                carousel?.current?.prev();
            }}
        />
        <Button
            shape="circle"
            size="large"
            icon={<FontAwesomeIcon icon={faArrowRight} />}
            disabled={isLast(current, totalCount)}
            onClick={() => {
                carousel?.current?.next();
            }}
        />
    </div>
);

export { ControlButtons };
